import script from "./CommitterStatSummaryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CommitterStatSummaryTable.vue?vue&type=script&setup=true&lang=js"

import "./CommitterStatSummaryTable.vue?vue&type=style&index=0&id=4c19870b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c19870b"]])

export default __exports__